<template>
    <!-- 案例 -->
    <div>
        <myheader :messages="parentMessage"></myheader>
        <!--  -->
        <div class="aboutopcomm w1750 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
            <div class="mk wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                <div class="h">将想法与焦点和您一起共享</div>
                <div class="p">建站知识、设计分享...用文字来标注每一次的新发现</div>
                <div class="moreboxmax">
                    <div class="a a1" @click="kefuclick"><i>在线咨询</i></div> 
                      <div class="a a2" @click="baojia">获取报价</div>
                </div>
            </div>
        </div>
        <div class="caseboxmax wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s">
            <div class="toop">
                <div class="li" :class="[this.querInfo.classifyid==''?'cur':'']" @click="newsall">所有</div>
                <div class="li" v-for="(item,index) in newsnav" :key="index" :class="[item.id==querInfo.classifyid?'cur':'']" @click="topclick(item.id)">{{item.title}}</div>
            </div>
            <div class="list" v-if="this.querInfo.classifyid==''">
                <a class="li" v-for="(item,index) in newstui" :key="index" :href="newsHref(item.id)" target="_blank" rel="noopener noreferrer">
                    <div class="m"><img :src="item.pic" alt=""></div>
                    <div class="p">{{item.title}}</div>
                </a>
            </div>
            <div class="boot wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                <a class="li" v-for="(item,index) in newslist" :key="index" :href="newsHref(item.id)" target="_blank" rel="noopener noreferrer">
                    <div class="t">{{ parseTime(item.addtime, '{y}/{m}/{d}') }}</div>  <!-- {y}-{m}-{d} {h}:{m} -->
                    <div class="h">{{item.title}}</div>
                    <div class="p">{{item.brief}}</div>
                </a>
            </div>
            <div class="padeing wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                <!-- <div class="li cur">01</div>
                <div class="li">02</div>
                <div class="li">03</div>
                <div class="li prev">上一页</div>
                <div class="li next">下一页</div> -->
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="querInfo.pageNum"
				:page-size="querInfo.pageSize"
                background
                layout="prev, pager, next"
				hide-on-single-page
                :total="total"></el-pagination>
            </div>
        </div>
        <!--   -->
        <myfooter></myfooter>
        <!--  -->
        <upsform :upunm="baoMessage" @updateEvent="handleUpdate"></upsform>
    </div>
</template>

<script>
    import myfooter from './footer.vue'
    import myheader from './header.vue'
    import upsform from './upform.vue'
    
    export default {
        data() {
            return {
                parentMessage: 3,
                baoMessage: false,
                newslist: [],
                newsnav: [],
                querInfo: {
                    classifyid: '',
                    pageNum: 1,
                    pageSize: 8
                },
                total: 0,
                newstui: []
            }
        },
        created() {
            this.getNewslist()
            this.getNewstui()
        },
        methods: {
            handleUpdate(updatedValue) {
                  this.baoMessage = updatedValue; // 更新父组件的Prop值
            },
            topclick(id){
                this.querInfo.classifyid = id
                this.getNewslist()
            },
            newsall(){
                this.querInfo.classifyid = ''
                this.getNewslist()
            },
            async getNewstui(){
                var url = `/api/news/recommend`
                const { data: res } = await this.$http.post(url)
                
                this.newstui = res.data
            },
            async getNewslist(){
                var url = `/api/news/list?classifyid=${this.querInfo.classifyid}&pageNum=${this.querInfo.pageNum}&pageSize=${this.querInfo.pageSize}`
                const { data: res } = await this.$http.post(url)
                
                this.newslist = res.data.rows
                this.newsnav = res.types
                this.total = res.data.total
            },
            handleSizeChange(newSize) {
                this.querInfo.pageSize = newSize
                this.getNewslist()
            },
            handleCurrentChange(newPage) {
                this.querInfo.pageNum = newPage
                this.getNewslist()
            },
            newsHref(id){
                return this.$router.resolve({
                    path: '/newsdata',
                    query: { id }
                }).href
            },
            parseTime(time, pattern) {
                  if (arguments.length === 0 || !time) {
                    return null
                  }
                  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
                  let date
                  if (typeof time === 'object') {
                    date = time
                  } else {
                    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
                      time = parseInt(time)
                    } else if (typeof time === 'string') {
                      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
                    }
                    if ((typeof time === 'number') && (time.toString().length === 10)) {
                      time = time * 1000
                    }
                    date = new Date(time)
                  }
                  const formatObj = {
                    y: date.getFullYear(),
                    m: date.getMonth() + 1,
                    d: date.getDate(),
                    h: date.getHours(),
                    i: date.getMinutes(),
                    s: date.getSeconds(),
                    a: date.getDay()
                  }
                  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
                    let value = formatObj[key]
                    // Note: getDay() returns 0 on Sunday
                    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
                    if (result.length > 0 && value < 10) {
                      value = '0' + value
                    }
                    return value || 0
                  })
                  return time_str
            },
            baojia() {
                this.baoMessage = true;
            },
            kefuclick(){
                const url = 'https://p.qiao.baidu.com/cps4/chatIndex?siteToken=fa6b3d5361002f77431328216553694d&speedLogId=16216501944184228_1621650194418_93941&eid=25401671&reqParam=%7B%22from%22%3A0%2C%22sid%22%3A%22-100%22%2C%22tid%22%3A%22-1%22%2C%22ttype%22%3A1%2C%22siteId%22%3A%2211856238%22%2C%22userId%22%3A%2225401671%22%2C%22pageId%22%3A0%7D';
                // window.location.href = url;
                window.open(url)
            }
        },
        components: {
        	myfooter, myheader, upsform
        }
    }
</script>

<style>

</style>